import React, { useState, useContext, useEffect } from 'react'
import { Modal, Spin, Input, DatePicker, Row, Col, message } from 'antd'
import moment from 'moment'

import { UnitSelection } from 'core/component/UnitSelection'
import { UnitSelectionContext, ErrorContext } from 'context'

const RiveSystemGroupModal = ({
  hide,
  data = {},
  updateTask,
  createTask,
  isLoading = false,
  // unitNameMap,
  availableUnits,
  utilityNameMap,
  list,
  // popModal,
  ...props
}) => {
  // const { selectedUnits, setVisibleUnitSelection, setSelectedUnits } = useContext(
  //   UnitSelectionContext
  // )

  const { setVisibleUnitSelection } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)
  const processing = isLoading
  const { isNew = false } = data
  const [baseData, setBaseData] = useState(
    isNew
      ? { ...data, units: [], effectiveDate: moment(), river: undefined }
      : { ...data, effectiveDate: moment(data.effectiveDate, 'YYYY-MM-DD') }
  )

  const [selectedUnits, setSelectedUnits] = useState(baseData.units)

  // const [err, setErr] = useState()
  // const [selectedUnits, setSelectedUnits] = useState(
  //   availableUnits.filter(unit => (data.units || []).some(i => i === unit.unitId))
  // )

  useEffect(() => {
    setVisibleUnitSelection(true)
    setSelectedUnits(
      availableUnits.filter(unit =>
        (data.units || []).some(i => i === unit.unitId)
      )
    )
  }, [availableUnits, data.units, setVisibleUnitSelection])

  const onOk = () => {
    const finalData = {
      ...baseData,
      effectiveDate: baseData.effectiveDate.format('YYYY-MM-DD'),
      units: selectedUnits.map(u => u.unitId),
    }

    if (finalData.river === undefined || finalData.river.trim() === '') {
      message.error('Group name must be entered.')
    } else if (finalData.units.length === 0) {
      message.error('There must be at least one unit assigned to the group.')
    } else if (
      isNew &&
      list.find(
        l => l.river.toLocaleLowerCase() === finalData.river.toLocaleLowerCase()
      )
    ) {
      message.error('Same Group Name found, Plase rename the Group Name')
    } else {
      setVisibleUnitSelection(false)
      if (isNew) {
        createTask(finalData).fork(e => setError(e, () => hide(null)), hide)
      } else {
        updateTask(finalData).fork(e => setError(e, () => hide(null)), hide)
      }
    }
  }

  return (
    <Modal
      title={isNew ? 'New Unit Group' : 'Edit Unit Group'}
      width="80vw"
      visible
      onOk={onOk}
      okText="Save"
      onCancel={() => {
        hide()
        setVisibleUnitSelection(false)
      }}
      centered
      bodyStyle={{ maxHeight: '80vh' }}
      maskClosable={false}
      okButtonProps={{ loading: processing }}
      cancelButtonProps={{ loading: processing }}
      afterClose={() => setVisibleUnitSelection(false)}
      destroyOnClose
      zIndex={800}
    >
      <Spin spinning={processing}>
        <Row gutter={12}>
          <Col span={3}>
            <label>Group Name : </label>
          </Col>
          <Col span={10}>
            <Input
              disabled={!isNew}
              maxLength={50}
              placeholder="Enter Group Name"
              value={baseData.river}
              onChange={e =>
                setBaseData({ ...baseData, river: e.target.value })
              }
            />
          </Col>
          <Col span={3}>
            <label>Effective Date : </label>
          </Col>
          <Col span={8}>
            <DatePicker
              disabled={!isNew}
              allowClear={false}
              format="MM/DD/YYYY"
              value={baseData.effectiveDate}
              onChange={value =>
                setBaseData({ ...baseData, effectiveDate: value })
              }
            />
          </Col>
        </Row>
        {/* <Row gutter={12}>
          <Col gutter={12} style={{ marginTop: '10px', maxHeight: '120px', overflow: 'auto' }}>
            {selectedUnits.map(unit => (
              <Tag color="blue">
                {unitNameMap[unit.unitId]} - {unit.unitId}
              </Tag>
            ))}
          </Col>
        </Row> */}
        <UnitSelection
          units={availableUnits}
          selectedUnits={selectedUnits}
          // setSelectedUnits={setSelectedUnits}
          utilityNameMap={utilityNameMap}
          renderBottomControls={() => <></>}
          onConfirm={setSelectedUnits}
          setCheckedItems={setSelectedUnits}
          checked={selectedUnits}
          unitTypeCode={props.unitTypeCode}
          unitGroups={props.unitGroups}
        />
      </Spin>
    </Modal>
  )
}
export default RiveSystemGroupModal
